module.exports = __webpack_public_path__ + "static/img/product_banner_21_zh.d2259ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_21_zh.png
// module id = 5ziJ
// module chunks = 34